import type { Locale } from "@/i18n/types";
import {
  GOOGLE_PLAY_LISTING_URL,
  googlePlayBadgeSrc,
  isExternalPlayStoreUrl,
} from "@/config/googlePlay";

type Props = {
  locale: Locale;
  ariaLabel: string;
  className?: string;
  imgClassName?: string;
};

export function GooglePlayBadgeLink({
  locale,
  ariaLabel,
  className = "inline-block rounded-lg transition-transform hover:scale-[1.02] active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#4CAF50]",
  imgClassName = "h-[52px] w-auto",
}: Props) {
  const src = googlePlayBadgeSrc(locale);
  const external = isExternalPlayStoreUrl(GOOGLE_PLAY_LISTING_URL);

  return (
    <a
      href={GOOGLE_PLAY_LISTING_URL}
      {...(external
        ? ({ target: "_blank", rel: "noopener noreferrer" } as const)
        : {})}
      className={className}
      aria-label={ariaLabel}
    >
      <img src={src} alt="" decoding="async" className={imgClassName} />
    </a>
  );
}
